export * from "./CasinoSlimSdk";
export var mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./mocks");
}
//# sourceMappingURL=index.js.map